import React from 'react';
import { profileData } from '../Database/profile-data';

const BioContext = React.createContext({});

export const BioContextProvider = (props) =>{
   return (<BioContext.Provider value={profileData}>
        {props.children}
    </BioContext.Provider>)
}

export default BioContext;